<template>
  <div class="margin-top-20" v-if="images.length">
    <cool-light-box
      :index="index"
      :items="images"
      :slideshow="false"
      @close="index = null"
      overlayColor="rgba(255, 255, 255, .9)">
    </cool-light-box>

    <div>
      <img :key="imageIndex"
           :src="image.thumb"
           @click="index = imageIndex"
           class="attachment-thumbnail"
           v-for="(image, imageIndex) in images"/>
    </div>
  </div>
</template>

<script>
  import CoolLightBox from 'vue-cool-lightbox'

  export default {
    components: {
      CoolLightBox
    },
    name: 'ReviewAttachments',
    props: {
      attachments: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      images() {
        const items = []
        this.attachments.forEach(function (attachment) {
          items.push({
            src: attachment.folderUrl + attachment.name,
            thumb: attachment.folderUrl + 'thumbnail_' + attachment.name
          })
        });
        return items
      }
    },
    data() {
      return {
        index: null
      };
    }
  }
</script>

<style scoped>
  .attachment-thumbnail {
    cursor: pointer;
    width: 20%;
    max-width: 80px;
    padding-right: 5px;
  }

  @media screen and (min-width: 768px) {
    .attachment-thumbnail {
      padding-right: 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/ReviewAttachments.vue